import React, {Fragment} from 'react';
import ComponentField from '../../form/ComponentField';
import createForm from "./Form";
import {UnitConvertComponent} from "src/components/classes/Unit";
import {connect} from "src/store";
import MaterialEditor from "src/components/editors/MaterialEditor";
import ModalEditor from "src/components/editors/ModalEditor";
import Button from "src/components/form/Button";
import PartnerEditor from "src/components/editors/partnerEditor";
import ProductMaterialEditor from "src/components/editors/ProductMaterialEditor";
import {get} from "src/utils/dotutils";
import {optionsTemplate} from "src/utils/formatters";
import Select from "src/components/form/Select";

class ProductMaterialForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />    
                    </div>
                    <div className="col-md-4">
                        <label className="control-label">Nyersanyag</label>
                        <div className="input-group">
                            <Select
                                objectValue={true}
                                name="material"
                                value={this.props.values.material}
                                component="Material"
                                view={["unit"]}
                                storeType="remote"
                                saveChanges={this.props.setFieldValue}
                                label={false}
                                {...this.props.getFieldProps("material")}
                            />
                            <MaterialEditor
                                editorContext="ProductMaterialMaterialEditor"
                                editor={ModalEditor}
                                other={() => null}
                                selection={null}
                                newButton={(props) => {
                                    return <Button
                                        type="button"
                                        {...props}
                                        disabled={props.disabled}
                                        children=""
                                        color="default"
                                        icon={{lib: "fas", name: "search"}}
                                        className="pull-left"
                                    />
                                }}
                                list={(listProps) => {
                                    return <Fragment>
                                        <div className="input-group-btn">
                                            {listProps.footer}
                                        </div>
                                    </Fragment>;
                                }}
                                saveForm={async (data, componentConfig, editorProps) => {
                                    this.props.setFieldValue("material", data);
                                    await editorProps.setFormValues({});
                                }}
                            />
                        </div>
                    </div>
                    <div className="col-md-4 unit">
                        <UnitConvertComponent
                            value={this.props.values.qty}
                            unit={this.props.values.material?.unit}
                        >
                            {({convertFrom, value, formatted}) => <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="qty"
                                values={{qty: value}}
                                setFieldValue={(field, value) => this.props.setFieldValue(field, convertFrom(value))}
                                label="Mennyiség"
                                negative={true}
                                formatter={() => formatted}
                                placeholder={(() => formatted?.props?.children || "")}
                                type="decimal"
                            />}
                        </UnitConvertComponent>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(connect((state) => {
    return {
        units: state.app.context.units,
    }
})(ProductMaterialForm));
